import { isPlainObject } from './util/object-utils';

export function isNotEmptyObject(obj: any): any {
	return isPlainObject(obj) && Object.keys(obj).length > 0;
}
